import { LEGAL_DOC_KEYS, LEGAL_DOCS } from '@plt/emails'

import type { Lang } from './lang.ts'

/**
 * Legal pages brief (13 October 2026), item 3: "ÁSZF" and "Adatkezelési
 * tájékoztató" (EN "Terms and Conditions", "Privacy Notice") in the footer of
 * every customer page, in the page's language. The static legal pages draw
 * the same markup from `apps/web/legalPages.ts`.
 *
 * Plain links to static files: a full page load, so the documents are read
 * without the application and without starting an order. `barClear` is for
 * the ordering page, whose fixed offer bar covers the bottom of one column.
 */
export function LegalFooter(props: { lang: Lang; barClear?: boolean }): JSX.Element {
  const { lang } = props
  return (
    <footer className={`site-footer${props.barClear ? ' bar-clear' : ''}`} data-testid="legal-footer">
      <nav aria-label={lang === 'en' ? 'Legal documents' : 'Jogi dokumentumok'}>
        {LEGAL_DOC_KEYS.map((doc, index) => (
          <span key={doc}>
            {index > 0 ? <span aria-hidden="true"> · </span> : null}
            <a href={LEGAL_DOCS[doc][lang].path}>{LEGAL_DOCS[doc][lang].label}</a>
          </span>
        ))}
      </nav>
    </footer>
  )
}
